// workAreas/hooks/usePricing.js
import { useState } from 'react';

export const usePricing = (VAT_RATE = 20) => {
  const [prices, setPrices] = useState({});
  const [isUpdatingPrice, setIsUpdatingPrice] = useState(false);

  const handlePriceChangeWithoutVAT = (workAreaSlug, value) => {
    if (isUpdatingPrice) return;

    setIsUpdatingPrice(true);
    const numValue = parseFloat(value) || 0;
    const priceWithVAT = parseFloat((numValue * (1 + VAT_RATE / 100)).toFixed(2));

    setPrices(prev => ({
      ...prev,
      [workAreaSlug]: {
        withoutVAT: numValue,
        withVAT: priceWithVAT
      }
    }));

    setTimeout(() => setIsUpdatingPrice(false), 0);
  };

  const handlePriceChangeWithVAT = (workAreaSlug, value) => {
    if (isUpdatingPrice) return;

    setIsUpdatingPrice(true);
    const numValue = parseFloat(value) || 0;
    const priceWithoutVAT = parseFloat((numValue / (1 + VAT_RATE / 100)).toFixed(2));

    setPrices(prev => ({
      ...prev,
      [workAreaSlug]: {
        withoutVAT: priceWithoutVAT,
        withVAT: numValue
      }
    }));

    setTimeout(() => setIsUpdatingPrice(false), 0);
  };

  const initializePricing = (workAreas) => {
    const newPrices = {};

    workAreas.forEach(workArea => {
      newPrices[workArea.slug] = prices[workArea.slug] || {
        withoutVAT: 20,
        withVAT: 20 * (1 + VAT_RATE / 100)
      };
    });

    setPrices(newPrices);
  };

  return {
    prices,
    isUpdatingPrice,
    handlePriceChangeWithoutVAT,
    handlePriceChangeWithVAT,
    initializePricing
  };
};